import * as swcHelpers from '@swc/helpers';
import { SUBSCRIPTIONS_CHANNEL_KEY } from '../constants.js';
import { getDiscount } from './get-discount.js';
import { getDiscountDescription } from './get-discount-description.js';
import { getPrice } from './get-price.js';

const getPermyriadFromAbsoluteDiscount = ({ originalPrice , discountedPrice  })=>{
    if (!discountedPrice) {
        return 0;
    }
    return (1 - discountedPrice / originalPrice) * 10000;
};
const getDiscountPermyriad = (serverPrice, clientPrice)=>{
    var ref, ref1, ref2;
    if (!serverPrice || !clientPrice) {
        return 0;
    }
    const serverDiscount = (ref = serverPrice.discounted) === null || ref === void 0 ? void 0 : (ref1 = ref.discount) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.value;
    if ((serverDiscount === null || serverDiscount === void 0 ? void 0 : serverDiscount.type) === 'relative') {
        return serverDiscount.permyriad;
    } else if (clientPrice.discountedPrice && (serverDiscount === null || serverDiscount === void 0 ? void 0 : serverDiscount.type) === 'absolute') {
        return getPermyriadFromAbsoluteDiscount(clientPrice);
    }
    return 0;
};
const mapToPurchaseTypePrices = (prices, locale)=>{
    if (!prices || prices.length === 0) {
        return {
            'single-purchase': undefined,
            'subscription-purchase': undefined
        };
    }
    // The first array item is always the single purchase price
    const [rawSinglePurchasePrice, ...rawPrices] = prices;
    const rawSubscriptionPurchasePrice = rawPrices.find((price)=>{
        var ref, ref3;
        return (price === null || price === void 0 ? void 0 : (ref = price.channel) === null || ref === void 0 ? void 0 : (ref3 = ref.obj) === null || ref3 === void 0 ? void 0 : ref3.key) === SUBSCRIPTIONS_CHANNEL_KEY;
    });
    const singlePurchasePrice = getPrice([
        rawSinglePurchasePrice
    ]);
    const subscriptionPurchasePrice = rawSubscriptionPurchasePrice ? getPrice([
        rawSubscriptionPurchasePrice
    ]) : undefined;
    /**
   * The subscription price discount should always be a relative discount with a permyriad,
   * but the single price could have either 1. No discount, 2. A relative discount, or 3. An absolute discount
   */ const singlePermyriad = getDiscountPermyriad(rawSinglePurchasePrice, singlePurchasePrice);
    const subscriptionPermyriad = getDiscountPermyriad(rawSubscriptionPurchasePrice, subscriptionPurchasePrice);
    // Calculate the difference between the two permyriads (if any)
    const percentSubscriptionSavings = (subscriptionPermyriad - singlePermyriad) / 100;
    // Then round the result to one decimal place
    const purchaseTypeSavings = percentSubscriptionSavings > 0 ? Math.round(percentSubscriptionSavings * 10) / 10 : undefined;
    return {
        'single-purchase': singlePurchasePrice && swcHelpers.objectSpread({}, singlePurchasePrice, {
            discountDescription: getDiscountDescription([
                rawSinglePurchasePrice
            ], locale),
            discountBadge: getDiscount([
                rawSinglePurchasePrice
            ], locale)
        }),
        'subscription-purchase': subscriptionPurchasePrice && rawSubscriptionPurchasePrice && swcHelpers.objectSpread({}, subscriptionPurchasePrice, {
            discountDescription: getDiscountDescription([
                rawSubscriptionPurchasePrice
            ], locale),
            discountBadge: getDiscount([
                rawSubscriptionPurchasePrice
            ], locale),
            purchaseTypeSavings
        })
    };
};

export { mapToPurchaseTypePrices };
//# sourceMappingURL=map-to-purchase-type-prices.js.map
